// export const toTextureAutoPrompt = (text: string) => {
// 	return text + ' 003 Poliigon highly detailed 4K texture';

// 	const end = text;

// 	// roughness : rough surface
// 	// lighting : golden hour, warm, cool, night, afternoon : neutral environment lighting, no shadows
// 	// aesthetic : photograph

// 	const middle =
// 		', straight-on overhead view of very flat surface, no shadows, neutral environment lighting, beautiful fc, 4K, diffuse map for PBR material substance, Quixel Studio, Unreal Engine asset store, Unity3D asset store, ';
// 	// return text + middle + end;
// 	return text;
// };

export const firstNCharacters = (text: string, n: number) => {
	if (text.length < n) {
		return text;
	}

	// get the first N characters
	const firstN = text.substring(0, n);
	// remove the last word
	return firstN.substring(0, firstN.lastIndexOf(' '));
};
